import React from 'react'
import UserFullName from '../../user/full-name'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { Col, Row } from 'react-bootstrap'

const MessageItemHeader = ({
    onToggle = () => {},
    subject,
    user,
    expanded
}) => {
    const iconSize = 20
    return (
        <Row className='noselect'><Col>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer'}} onClick={() => onToggle()}>
                <div style={{ flexGrow: '1', paddingTop: '10px', paddingBottom: '10px' }}>
                    <div><strong><UserFullName user={user}/></strong></div>
                    <div>{subject}</div>
                </div>
                <div>
                    {expanded && <ChevronUp size={iconSize} />}
                    {!expanded && <ChevronDown size={iconSize} />}
                </div>
            </div>
        </Col></Row>
    )
}

export default MessageItemHeader